import { useContext, useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import { showToast } from "../../showTost";
import { buildImageUrl, applyImageFallback } from "../../utils/image";

export default function DigitalCard() {
  const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openingId, setOpeningId] = useState(null);
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    if (!Userid) {
      setIsLoginShow(true);
      setLoading(false);
      return;
    }
    axios
      .post(`${ApiBaseUrl}/customer/home`, {
        id: Userid,
        lat: "0",
        lon: "0",
      })
      .then((r) => {
        setMembers(r.data.family_member || r.data.familyMember || []);
      })
      .catch(() => showToast({ title: "Could not load family members", id: "error" }))
      .finally(() => setLoading(false));
  }, [Userid, ApiBaseUrl, setIsLoginShow]);

  const openCard = (member) => {
    setOpeningId(member.id);
    axios
      .post(`${ApiBaseUrl}/customer/digital_card_link`, {
        id: Userid,
        target_id: String(member.id),
        target_type: "family",
      })
      .then((r) => {
        if (r.data.Result && r.data.digital_card_url) {
          window.open(r.data.digital_card_url, "_blank", "noopener,noreferrer");
        } else {
          showToast({
            title: r.data.message || "Digital card is not available yet",
            id: "error",
          });
        }
      })
      .catch(() =>
        showToast({ title: "Digital card service unavailable", id: "error" })
      )
      .finally(() => setOpeningId(null));
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-rm-ink mb-2">Digital Health Pass</h1>
      <p className="text-gray-600 text-sm mb-6">
        Open a digital health card for yourself or a family member.
      </p>

      {loading ? (
        <p className="text-center text-gray-500 py-10">Loading…</p>
      ) : members.length === 0 ? (
        <div className="text-center py-16 border rounded-xl bg-white">
          <p className="font-medium text-lg">No family members found</p>
          <p className="text-gray-500 mt-1">Add a patient from the home page first.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {members.map((m) => (
            <div
              key={m.id}
              className="border rounded-xl p-4 bg-white flex items-center justify-between gap-3"
            >
              <div className="flex items-center gap-3 min-w-0">
                <img
                  src={buildImageUrl(ImgBaseUrl, m.profile_image, "patient")}
                  onError={(e) => applyImageFallback(e, ImgBaseUrl, "patient")}
                  alt=""
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <p className="font-semibold truncate">{m.name}</p>
                  <p className="text-sm text-gray-500 truncate">
                    {[m.relation || m.relationship, m.blood_group || m.blood_type].filter(Boolean).join(" · ") ||
                      "Family member"}
                  </p>
                </div>
              </div>
              <button
                className="bg-[#0d9488] text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap disabled:opacity-60"
                disabled={openingId === m.id}
                onClick={() => openCard(m)}
              >
                {openingId === m.id ? "Opening…" : "Open card"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
